export const pricingCardContainerStyles =
  'shadow-card bg-neutral-N00 relative flex min-h-[22.375rem] w-[18.75rem] flex-col items-center justify-end self-end rounded-[0.625rem] border border-solid border-neutral-N20 px-6 py-9';

export const cardTitleStyles = 'text-blog-body mb-8';

export const priceWrapperStyles =
  'flex gap-3 items-center text-body-l mb-8 h-[1.5625rem]';

export const footnoteStyles =
  'flex gap-2.5 items-center text-body-m mt-4 uppercase text-neutral-N40 min-h-[1.25rem]';

export const ctaContainerStyles = 'w-[252px] md:w-full';

export const contactSalesDescriptionStyles =
  'text-body-m text-neutral-N50 mb-8 text-center';
